export const confirmBillingContract = async ({apiClient, organizationId, contract}) => {
    try {
        const response = await apiClient.post(
            `/api/organizations/${organizationId}/confirm_billing_contract`,
            {lock_version: contract.lock_version},
        );
        return {contract: response.data.billing_contract, catalog: response.data.catalog, refreshed: false};
    } catch (error) {
        if (error?.response?.status !== 409) throw error;

        const response = await apiClient.get(`/api/organizations/${organizationId}/billing_contract`);
        return {contract: response.data.billing_contract, catalog: response.data.catalog, refreshed: true};
    }
};

export const createLatestBillingRequestGuard = () => {
    let sequence = 0;
    return {
        start: () => ++sequence,
        invalidate: () => ++sequence,
        isCurrent: token => token === sequence,
    };
};
